import http from "@/services/http";
import { featureFlags } from "@/config/env";
import { mockManager } from "@/services/mock";

export interface QuestionCiteListParams {
  taskId: string;
  brandId?: string;
  categoryId?: string;
  days?: number;
  metricType?: string;
  modelId?: string;
  page?: number;
  pageSize?: number;
}

export interface QuestionCiteItem {
  title: string;
  url: string;
  snippet: string;
  siteName: string;
  siteIcon: string;
  citeIndex: number;
  publishTime: string;
}

export interface QuestionCiteListResponse {
  code: number;
  message: string;
  data: {
    taskId: string;
    list: QuestionCiteItem[];
    total: number;
    page: number;
    pageSize: number;
  };
}

export const questionCitelistApi = {
  async getQuestionCiteList(
    params: QuestionCiteListParams
  ): Promise<QuestionCiteListResponse["data"]> {
    if (featureFlags.enableMock) {
      console.log("[Mock] get-question-citelist", params);
      return await mockManager.getQuestionCiteList(params);
    }

    try {
      console.log("[API] get-question-citelist request:", params);
      const response = await http.get<QuestionCiteListResponse>(
        "data/brand/question/citelist",
        { params }
      );
      console.log("[API] get-question-citelist response:", response.data);

      return response.data.data;
    } catch (err) {
      console.error("[API] get-question-citelist error:", err);
      return {
        taskId: params.taskId,
        list: [],
        total: 0,
        page: params.page || 1,
        pageSize: params.pageSize || 20,
      };
    }
  },
};

export default questionCitelistApi;
